import angular from 'angular';
import gettext from 'angular-gettext';
import toastr from 'angular-toastr';
import UserResource from '../../cmsCore/UsersModules/UserResource'
import LastLogOptions from './LastLogOptions';
import CMSAuthService from '../../cmsCore/Auth/CMSAuthService';
import config from '../../cmsCore/ConfigModule/ConfigModule';
import deleteElementDialog from '../../cmsCore/DeleteElementModal/deleteElement';

let usersPageEditModule = angular.module('cms.users.edit', [UserResource, gettext, toastr, CMSAuthService, LastLogOptions, config, deleteElementDialog])
    .component('appUsersEdit', {
        template: require('./templates/usersEdit.html'),
        controller: function (
            UserResource,
            $stateParams,
            $state,
            toastr,
            gettextCatalog,
            CMSAuthService,
            LastLogOptions,
            CONFIG,
            deleteElementDialog,
            SaveWarning
        ) {

            /** @ngInject */

            this.user = {};
            this.user.roles = [];
            this.errors = {};

            this.roles = CONFIG.ROLES.map(roleName => { return {name: roleName, selected: false }});

            this.isMe = false;
            this.showSettingsSection = false;

            /* Grid */
            this.gridOptions = LastLogOptions;
            this.initialParams = {
                ownerId: $stateParams.id,
            };

            function goToReturnState() {
                SaveWarning.stopWatch();
                if ($stateParams.returnState) {
                    $state.go($stateParams.returnState.name, $stateParams.returnState.params)
                } else {
                    $state.go('users', {})
                }
            }

            this.isChecked = role => {
                return this.user.roles.indexOf(role) > -1;
            };

            this.user.id = $stateParams.id;

            UserResource.find(this.user,
                response => {
                    this.user = response;
                    SaveWarning.watch(response, this.user);

                    this.isMe = CMSAuthService.getUser().id === response.id;

                    if (!this.user.isLdapUser && !this.isMe) {
                        this.showSettingsSection = true;
                    }

                    if (response.roles) {
                        this.roles.forEach(role => {
                            this.user.roles.forEach(userRole => {
                                if (userRole === role.name) {
                                    role.selected = true;
                                }
                            });
                        });
                    } else {
                        this.roles = null;
                    }

                },
                errResponse => {
                }
            );

            this.saveChanges = () => {
                UserResource.update(this.user,
                    response => {
                        this.errors = {};

                        toastr.success(
                            gettextCatalog.getString('User {{username}} updated!', {username: this.user.username}),
                            gettextCatalog.getString('Success')
                        );
                        goToReturnState();
                    },
                    errResponse => {
                        this.errors = errResponse.data;
                    }
                );
            };

            this.delete = () => {
                UserResource.delete({id: this.user.id}, response => {
                    toastr.success(
                        gettextCatalog.getString('User {{username}} deleted!', {username: this.user.username}),
                        gettextCatalog.getString('Success')
                    );
                    $state.go('users');
                });
            };

            this.enabled = () => {
                let request = {id: this.user.id, enabled: this.user.enabled};
                UserResource.update(request, response => {
                })
            };

            this.confirmDelete = () => {
                let deleteMessage = gettextCatalog.getString("Do you really want to delete this account? (This action is irreversible!)");
                deleteElementDialog.open(deleteMessage).then(() => {
                    this.delete();
                }).catch( () => {});
            };

            this.submitRoles = () => {
                let newRoles = [];
                this.roles.forEach((role) => {
                    if (role.selected) {
                        newRoles.push(role.name);
                    }
                });

                let request = {roles: newRoles, id: this.user.id};

                UserResource.update(request, response => {
                    this.user.roles = response.roles;
                    toastr.success(
                        gettextCatalog.getString('User {{username}} updated!', {username: this.user.username}),
                        gettextCatalog.getString('Success')
                    );
                }, errResponse => {
                    toastr.error(gettextCatalog.getString('There was a problem processing your request. Try again later.'),
                                 gettextCatalog.getString('System error'));

                })
            };

            this.onCancel = () => {
                goToReturnState();
            };
        }
    });

export default usersPageEditModule.name;




// WEBPACK FOOTER //
// ./src/cmsPages/Users/UsersEditPageDirective.js